import axiosInstance from "./api";

export const getCSVExport = async ({ fileName, exportUrl }) => {
  try {
    const response = await axiosInstance.get(exportUrl, {
      responseType: "blob",
    });

    if (response.status !== 200) {
      console.error("There was an error querying.");
      throw new Error("There was an error querying.");
    }
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
    return true;
  } catch (error) {
    console.error("Error exporting CSV:", error);
    return false;
  }
};

export const getJsonExport = async ({ fileName, jsonData }) => {
  try {
    const dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(jsonData, null, 2));
    const link = document.createElement("a");
    link.href = dataStr;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
    return true;
  } catch (error) {
    console.error("Error exporting JSON:", error);
    return false;
  }
};

export const exportService = {
  getCSVExport,
  getJsonExport,
};

export default exportService;
